import { accessGlobalUserState } from "../stores/user";

export function isLoggedIn() {
  const userStore = accessGlobalUserState().get();
  return Boolean(userStore.token);
}
